module.exports = __webpack_public_path__ + "img/logo-w.7a55a261.png";